import { useCallback, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";

export function useListViewColumnFilter({
  filterKey,
  resetKey,
  parseSelectedItems = (value) => value,
  isResetBlocked = (value) => !Number.isNaN(Number(value)),
}) {
  const [searchParams, setSearchParams] = useSearchParams();
  const [anchorEl, setAnchorEl] = useState(null);

  const selectedItems = useMemo(() => {
    const value = searchParams.get(filterKey);

    if (!value) {
      return [];
    }

    return value.split(",").map(parseSelectedItems);
  }, [filterKey, parseSelectedItems, searchParams]);

  const isPrimaryFilterActive = useMemo(
    () => isResetBlocked(searchParams.get(resetKey)),
    [isResetBlocked, resetKey, searchParams]
  );

  const updateSearchParams = useCallback(
    (nextValues) => {
      const nextSearchParams = new URLSearchParams(searchParams);

      if (nextValues?.length) {
        nextSearchParams.set(filterKey, nextValues.join(","));
      } else {
        nextSearchParams.delete(filterKey);
      }

      setSearchParams(nextSearchParams);
    },
    [filterKey, searchParams, setSearchParams]
  );

  const handleSelectionChange = useCallback(
    (nextSelection) => {
      updateSearchParams(nextSelection);
    },
    [updateSearchParams]
  );

  const handleClearFilter = useCallback(() => {
    updateSearchParams([]);
  }, [updateSearchParams]);

  const handleClick = useCallback((event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  }, []);

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  return {
    anchorEl,
    handleClearFilter,
    handleClick,
    handleClose,
    handleSelectionChange,
    isPrimaryFilterActive,
    selectedItems,
  };
}
